app.controller('createEmailController', async function ($scope, safeApply, systemToolsService) {

  let table
  const tableID = '#emailCreatorSQLTable'

  $scope.requiredFields = []

  // Handle data-tables being hidden when on modal with columns being off
  var myModalEl = document.getElementById('sqlModal')
  myModalEl.addEventListener('shown.bs.modal', function (event) {
    $($.fn.dataTable.tables(true)).DataTable()
      .columns.adjust();
  })

  $scope.email = {
    id: 2000,
    title: 'Past Due Invoice - First Notice',
    description: 'This is the first notice sent to a user when an invoice is past due.',
    sql:
      `-- tax_year is required
-- min_amount_due is required
-- sent_less_than is required
-- user_id if 0, send to all users, otherwise send to specific user

-- CALL PAST_DUE_ACCOUNTS({tax_year}, {min_amount_due}, {sent_less_than}, {user_id});
SELECT * from documents where id = {user_id};
`,
    html: `<style>
            .emailContainer {
              margin-top : 25px;
              width      : 100%;
              max-width  : 600px;
              text-align : justify;
              line-height: 1.3;
            }
            .emailContainer .h3 {
              font-size  : 20px;
              line-height: 1.2;
            }
            .emailContainer .h4 {
            font-size  : 15.21px;
            line-height: 1.2;
            }
            .emailContainer .fw-bold {
              font-weight: bold;
            }
            .emailContainer .underline {
              text-decoration: underline;
            }
            .emailContainer .text-justify {
              text-align: justify;
            }
            .emailContainer .pt-1 {
              padding-top: 12px;
              margin-top : 12px;
            }
            .emailContainer .pt-2 {
              padding-top: 6px;
              margin-top : 6px;
            }
            .emailContainer .regards {
              padding-top: 15px;
              margin-top : 15px;
            }
            .emailContainer .link-wrapper {
              margin    : 25px 0;
              text-align: center;
            }
            .emailContainer .link {
              letter-spacing  : 5px;
              font-size       : 15px;
              background-color: #0077B5;
              color           : white;
              padding         : 8px 19px;
              border-radius   : 45px;
              text-decoration : none;
            }
          </style>

          <div class="emailContainer">

            <div class="text-justify">
              <p>
                This is a reminder that an invoice was issued and is now showing as past due in our system. This is the second late
                notice we have sent to you. The original email (with a link to the invoice) is provided below.
              </p>    
              <p>
                We know that the original email could have been overlooked or possibly landed in your spam folder. We will not be
                applying any late payment penalties at this time.
              </p>    
              <p>
                You can submit a payment by check or credit card by viewing the invoice link.
              </p>
              <p class="link-wrapper">
                <a class="link" href="https://dashboard.propertytax.io/{{{user_id}}}/{{{token}}}/invoice">
                  VIEW INVOICE
                </a>
              </p>
              <p>
                Thank you and please respond to this email if you have any questions.
              </p>
              <p class="fw-bold">
                ### Original email below ###
              </p>

              <p>
                You are receiving this email because PropertyTax.io (Goodrich Realty Consulting, LLC) represented you in a property
                tax
                protest. We have completed work that resulted in tax savings for a property we protested on your behalf.
              </p>
              <p>
                You can view the full details of your property protest, including final values, exemptions, tax savings, and invoice
                amount by clicking the “View Invoice” button below.
                From there, you can pay by credit card or view instructions on how to pay by check.
              </p>
              <p class="link-wrapper">
                <a class="link"
                  href="https://dashboard.propertytax.io/{{{user_id}}}/{{{token}}}/invoice">
                  VIEW INVOICE
                </a>
              </p>
              <p>
                If you notice any issues (such as a missing exemption), please let us know.
              </p>
              <p>
                Be sure and click "View" under the Tax Savings Details column to view the
                details of how we calculated the tax savings (which exemptions were used,
                the taxing entities, etc.).
              </p>
              <p>
                Thank you for trusting our service to represent you in a property tax protest
                and we appreciate your continued business. Please let us know if there is
                anything we help you with at any time.
              </p>
              <br>
              <p>
                Sincerely,
                <br><br>
                PropertyTax.io Management
              </p>
              <br><br>
              <p style="text-align: center; color: gray;">
                <small>
                  If you have any issues with the "View Invoice" button above, you can cut-n-paste this link into your browser.
                  <br>
                  https://dashboard.propertytax.io/{{{user_id}}}/{{{token}}}/invoice
                </small>
              </p>

            </div>

                  </div>`,
    schema:
      `{
"email_id"        : { "type": "number",   "required": true,  "store": true,   "test": { "value": 2000 }},
"tax_year"        : { "type": "number",   "required": true,  "store": true,   "test": { "value": 2025 }},
"min_amount_due"  : { "type": "number",   "required": true,  "store": true,   "test": { "value": 5 },       "storage_value": 0 },
"sent_less_than"  : { "type": "number",   "required": true,  "store": true,   "test": { "value": 3 },       "storage_value": 99999 },
"user_id"         : { "type": "number",   "required": true,  "store": true,   "test": { "value": 0 },       "default": 0 },
"query_type"      : { "type": "string",   "required": false, "store": true,   "default": "query" },
"send_email"      : { "type": "boolean",  "required": false, "store": false,  "default": true },
"update_db"       : { "type": "boolean",  "required": false, "store": false,  "default": true },
"cc"              : { "type": "string",   "required": false, "store": false,  "default": "" },
"bcc"             : { "type": "string",   "required": false, "store": false,  "default": "" },
"subject"         : { "type": "string",   "required": false, "store": true,   "default": "Late notice for overdue property tax invoice." },
"sender"          : { "type": "object",   "required": false, "store": false,  "default": { "name": "PropertyTax.io Support Team", "email": "support@propertytax.io" } },
"reply"           : { "type": "object",   "required": false, "store": false,  "default": { "name": "PropertyTax.io Support Team", "email": "support@propertytax.io" } },
"test_mode"       : { "type": "boolean",  "required": false, "store": false,  "default": false },
"test_email"      : { "type": "string",   "required": false, "store": false,  "default": "bryanutley2000@yahoo.com" },
"record_wh_events": { "type": "boolean",  "required": false, "store": false,  "default": false },
"is_preview"      : { "type": "boolean",  "required": false, "store": false,  "default": false }
}`,
  }

  $scope.executeSQL = async () => {
    console.log('$scope.schema :>> ', $scope.schema);
    let data
    let sql = $scope.email.sql.replace(/--.*$/gm, '').trim()
    Object.keys($scope.schema)
      .forEach((key, value) => {
        sql = sql.replace(new RegExp(`\\{${key}\\}`, 'g'), $scope.schema[key].value)
      })
    console.log('sql :>> ', sql)
    let results = await systemToolsService.executeSQLStatement({ sql: sql, type: $scope.schema.query_type.value })
    console.log('results :>> ', results);
    $scope.results = results.data.data[0]

    if ($scope.schema.query_type.default == 'stored_procedure') {
      data = results.data.data[0]
    } else {
      data = results.data.data
    }

    let sqlColumns = []
    data.map((row, index) => {
      if (index == 0) {
        for (const [key, value] of Object.entries(data[0])) {
          sqlColumns.push({
            title: key,
            data: key,
            className: (typeof value == 'number') ? 'dt-body-right dt-head-right' : 'dt-body-left dt-head-left',
          })
        }
      }
      if (typeof row == 'object') {
        for (const [key, value] of Object.entries(row)) {
          let t = typeof value
          if (t == 'array') {
            data[index][key] = JSON.stringify(value)
          } else if (t == 'object') {
            data[index][key] = JSON.stringify(value)
          }
        }
      } else if (typeof row == 'array') {
        data[index] = JSON.stringify(row)
      }
    })
    console.log('sqlColumns :>> ', sqlColumns);
    let config = {
      data: data,
      scrollY: '40vh',
      scrollX: true,
      pagingType: 'full_numbers',
      dom: 'Bfrtip',
      // fixedColumns: false,
      keys: false,
      pageLength: 25,
      deferRender: false,
      lengthMenu: [
        [10, 25, 50, 100, -1],
        ['10 rows', '25 rows', '50 rows', '100 rows', 'Show all']
      ],
      buttons: ['pageLength', 'spacer', 'csv', 'excel'],
      columns: sqlColumns
    }
    table = $(tableID).DataTable(config)
    safeApply($scope)
    table.draw()
  }



  $scope.populateSchema = () => {
    $scope.schema = JSON.parse($scope.email.schema)
    Object.keys($scope.schema)
      .forEach((key, value) => {
        if ($scope.schema[key].hasOwnProperty("test")) {
          $scope.schema[key].value = $scope.schema[key].test.value
        } else {
          $scope.schema[key].value =
            ($scope.schema[key].hasOwnProperty("default"))
              ? ($scope.schema[key].type == 'object' && $scope.schema[key].default != '')
                ? JSON.stringify($scope.schema[key].default)
                : angular.copy($scope.schema[key].default)
              : null
        }
      })
    safeApply($scope)
  }
  $scope.populateSchema()

  $scope.schemaModalClose = () => {
    $scope.email.schema = JSON.parse($scope.email.schema)
    Object.keys($scope.schema)
      .forEach((key, value) => {
        if ($scope.schema[key].hasOwnProperty("test")) {
          $scope.schema[key].test.value = $scope.schema[key].value
        } else {
          $scope.schema[key].value =
            ($scope.schema[key].hasOwnProperty("default"))
              ? ($scope.schema[key].type == 'object' && $scope.schema[key].default != '')
                ? JSON.stringify($scope.schema[key].default)
                : angular.copy($scope.schema[key].default)
              : null
        }
      })
    $scope.email.schema = JSON.stringify($scope.schema, null, 2)
    safeApply($scope)
  }

  $scope.testModeToggle = () => {
    console.log($scope.test_mode_toggle)
    if ($scope.test_mode_toggle) {
      $scope.schema.update_db.value = false
      $scope.schema.test_mode.value = true
      $scope.schema.record_wh_events.value = false
    } else {
      $scope.schema.update_db.value = $scope.schema.update_db.default
      $scope.schema.test_mode.value = $scope.schema.test_mode.default
      $scope.schema.record_wh_events.value = $scope.schema.record_wh_events.default
    }
    safeApply($scope)
  }

  // $scope.prepSQL = () => {
  //   $scope.requiredFields = []
  //   for (const [key, value] of Object.entries(schema)) {
  //     if (value.required) {
  //       $scope.requiredFields.push({
  //         name : key,
  //         value: value.test.value
  //       })
  //     }
  //   }
  //   safeApply($scope)
  //   console.log('$scope.requiredFields :>> ', $scope.requiredFields)
  // }


})
